import { render } from "./BienBanGiaiTheTable.vue?vue&type=template&id=af370dd2&ts=true"
import script from "./BienBanGiaiTheTable.vue?vue&type=script&lang=ts"
export * from "./BienBanGiaiTheTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__